/**
 * Simple mergeWith implementation that deeply merges objects
 * @param {Object} target - Target object
 * @param {Object} source - Source object to merge
 * @returns {Object} Merged object
 */
const mergeWith = (target, source) => {
    const result = { ...target };

    for (const key in source) {
        if (Object.hasOwn(source, key)) {
            if (source[key] !== undefined) {
                if (
                    typeof source[key] === 'object' &&
                    source[key] !== null &&
                    !Array.isArray(source[key])
                ) {
                    result[key] = mergeWith(result[key] || {}, source[key]);
                } else {
                    result[key] = source[key];
                }
            }
        }
    }

    return result;
};

export { mergeWith };